import { floorElevationInfo } from './floorElevation.js';
import { formatLength } from './units.js';

/** An elevation entry is a planning assumption relative to Site ground.
 * Retain only its allowlisted original, not arbitrary floor metadata. */
export function floorElevationEvidence(floor) {
  const info = floorElevationInfo(floor), record = info.record;
  if (!record) throw new Error('This floor has no recorded elevation entry.');
  const copied = info.source === 'different-floor', changed = info.source === 'changed-after-entry';
  return { status: copied || changed ? 'geometry-changed' : 'assumption', severity: 'warning', assumption: true,
    assumptionCategory: 'operator-entered-floor-elevation',
    title: `${typeof floor.name === 'string' ? floor.name.slice(0, 120) : 'Floor'}: retained elevation input`,
    detail: `The operator entered a floor elevation relative to Site ground. This is not an independently verified vertical measurement.${copied ?
      ' The entry belongs to another floor; check the copied level independently.' : changed ?
      ' The current floor elevation differs from the original entry.' :
      ' The current floor elevation matches the retained entry.'} Wall, roof and camera heights are relative to their owning floors.`,
    floorElevation: { recordedMetres: record.signedMetres, currentMetres: info.elevation,
      recordedFloorID: record.recordedFloorID, basis: record.basis, side: record.side,
      createdAt: record.createdAt, sourceStatus: info.source,
      ...(record.manualInput ? { manualInput: structuredClone(record.manualInput) } : {}) } };
}

export function floorElevationEvidenceRows(item, doc) {
  const value = item.floorElevation;
  if (!value) return [];
  const rows = [['Elevation evidence', 'Operator-entered assumption — not independently verified'],
    ['Elevation basis', 'Signed height relative to Site ground'],
    ['Original elevation floor', value.recordedFloorID],
    ['Original entered floor elevation', formatLength(value.recordedMetres, doc, 3)],
    ['Current floor elevation', formatLength(value.currentMetres, doc, 3)],
    ['Original elevation recorded at', value.createdAt]];
  if (value.manualInput) {
    const manual = value.manualInput;
    rows.push(['Original elevation entry', `${manual.enteredText} · ${manual.explicitUnit ? 'explicit unit' : 'recorded Site unit'} ${manual.enteredUnit}${manual.decimalSeparator === ',' ? ' · decimal comma' : ''} · ${value.side} Site ground`]);
  }
  return rows;
}
